
const version = '1.3.8'
const preVersion = 'Beta'

/*
1.20
fixed notice modal for ipad
    - waiver
    - spearhead NOT NECESSARY
fixed login screen
potentially fixed offline login screen

1.2.1
hotfix for login logic
- fixed duplicate splashscreen display
- fixed login infinite loop
- fixed login kicking back to unauthenticated lgoin

1.2.2
- change name from feature search to Terrain Atlas
- adding features for offline mode


1.2.3
- adjustments to pin database entry

1.2.4
----


1.2.6

quick update to CDN to speed up tile fetching
speed up hang of liability modal
fixed pin creation issue
-----------
1.2.7

adjustments to the amplify environment
------------
1.28

updates to tile importing and exporting
fix to addition of cloudfront
optimization to tile loading via leaflet settings

updated logic surrounding map library display
updated logic surrouunding map containers and map tile display
    simplified to allow for speeding up

    1.2.9
update to caching and high resolution map fixes

1.3.0

minor fixes to the update notification

1.3.1
    changing s3 path to tiles
        increased to 2 tile layers, one with each png and jpeg
        may change this back
    removing low and high res options
    prepping for wb and bc maps to be separate
1.3.2 
    further updating to the tile fetching protocol
    removed the pngs, and kept only the jpegs
1.3.3
    removed the download button for offline use

1.3.4
    updated cloudfront components to ensure correct tiles

1.3.5
- adding privacy policy page
1.3.6
- adding privacy policy page fix
1.3.7
- updating logos
1.3.8
- fixing spearhead map
*/  
export {version, preVersion}